import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import AWS from 'aws-sdk';
import Amplify from 'aws-amplify';
// import VueCookies from 'vue-cookies';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faThumbsUp as farThumbsUp,
  faThumbsDown as farThumbsDown,
  faEdit as farEdit,
  faTrashAlt as farTrashAlt,
  faBell as farBell,
} from '@fortawesome/free-regular-svg-icons';
import {
  faThumbsUp as fasThumbsUp,
  faThumbsDown as fasThumbsDown,
  faChevronRight as fasChevronRight,
  faSearch as farSearch,
  faBullhorn as fasBullhorn,
  faSignOutAlt as fasSignOut,
  faPlus as fasPlus,
  faLock as fasLock,
  faLockOpen as fasLockOpen,
  faUsers as fasUsers,
  faUserClock as fasUserClock,
  faArrowUp as fasArrowUp,
  faFilter as fasFilter,
  faArrowDown as fasArrowDown,
  faClone as fasClone,
  faStopwatch as fasStopwatch,
  faLink as fasLink,
  faUser as fasUser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Cloudinary, { CldImage, CldTransformation } from 'cloudinary-vue';
import dotenv from 'dotenv';
import firebase from 'firebase';
import config from './aws-exports';
import App from './App.vue';
import router from './router';
import utils from './services/utils';
import store from './store';
import './assets/tailwind.css';

dotenv.config();
// support local development for amplify - configure needs the right redirect uri
const urlsIn = config.oauth.redirectSignIn.split(',');
const urlsOut = config.oauth.redirectSignOut.split(',');
const oauth = {
  domain: config.oauth.domain,
  scope: config.oauth.scope,
  redirectSignIn: config.oauth.redirectSignIn,
  redirectSignOut: config.oauth.redirectSignOut,
  responseType: config.oauth.responseType,
};
if (utils.isRunningOnLocalhost()) {
  urlsIn.forEach((e) => {
    if (utils.hasLocalhost(e)) {
      oauth.redirectSignIn = e;
    }
  });
  urlsOut.forEach((e) => {
    if (utils.hasLocalhost(e)) {
      oauth.redirectSignOut = e;
    }
  });
} else {
  urlsIn.forEach((e) => {
    if (utils.hasHostname(e)) {
      oauth.redirectSignIn = e;
    }
  });
  urlsOut.forEach((e) => {
    if (utils.hasHostname(e)) {
      oauth.redirectSignOut = e;
    }
  });
}
const configUpdate = config;
configUpdate.oauth = oauth;

// point to our domain
configUpdate.oauth.domain = 'auth.implicit.io';

AWS.config.region = configUpdate.aws_project_region;
Amplify.configure(configUpdate);

library.add(
  farThumbsUp,
  fasThumbsUp,
  farThumbsDown,
  fasThumbsDown,
  fasChevronRight,
  farEdit,
  farTrashAlt,
  farSearch,
  farBell,
  fasBullhorn,
  fasSignOut,
  fasPlus,
  fasFilter,
  fasLock,
  fasLockOpen,
  fasUsers,
  fasUserClock,
  fasArrowDown,
  fasArrowUp,
  fasClone,
  fasStopwatch,
  fasLink,
  fasUser,
);
// library.add(faCommentAlt, faBookmark, faShareSquare);
Vue.component('font-awesome-icon', FontAwesomeIcon);

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: ['UA-99650604-2', 'UA-99650604-1'],
  router,
});

Vue.use(Cloudinary, {
  configuration: { cloudName: 'dzgxzzwnu' },
  components: {
    CldImage,
    CldTransformation,
  },
});

new Vue({
  router,
  render: (h) => h(App),
  store,
  beforeCreate() {
    this.$store.commit('initialiseStore');
  },
}).$mount('#app');
